export default "__VITE_ASSET__bbdfdbfd__"